import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ReactMarkdown from 'react-markdown';
import { getHelpData, getHelpLoading } from './redux/selector';
import { fetchHelp } from './redux/actions';
import unescapeJs from 'unescape-js';
import { ContentBox } from '../../../shared/content-box/ContentBox';
import './Help.scss';

class HelpContainer extends Component {
    componentDidMount() {
        this.props.fetchHelp();
    }

    render() {
        const { help } = this.props;

        const parsedHelp = help && unescapeJs(help.data);

        return (
            <Fragment>
                <div className={'help container'}>
                    {help && (
                        <ContentBox
                            title={help.title}
                            content={
                                <ReactMarkdown
                                    escapeHtml={false}
                                    source={parsedHelp}
                                />
                            }
                        />
                    )}
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        help: getHelpData(state),
        loading: getHelpLoading(state)
    };
};

const mapDispatchToProps = dispatch => ({
    fetchHelp: () => dispatch(fetchHelp())
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(HelpContainer)
);
